import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import WeddinsiteLogo from "./WeddinsiteLogo";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Close mobile menu on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const NavLinks = ({ onClick }) => (
    <>
      <Link to="/templates" data-testid="nav-templates" onClick={onClick} className="hover:text-black transition-colors">Templates</Link>
      <Link to="/#features" data-testid="nav-features" onClick={onClick} className="hover:text-black transition-colors">Features</Link>
      <Link to="/#pricing" data-testid="nav-pricing" onClick={onClick} className="hover:text-black transition-colors">Pricing</Link>
      <Link to="/#help" data-testid="nav-help" onClick={onClick} className="hover:text-black transition-colors">Help</Link>
      {user && <Link to="/dashboard" data-testid="nav-dashboard" onClick={onClick} className="hover:text-black transition-colors">My Weddings</Link>}
      {user?.role === "admin" && <Link to="/admin" data-testid="nav-admin" onClick={onClick} className="hover:text-black transition-colors font-semibold">Admin</Link>}
    </>
  );

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/90 border-b border-stone-200" data-testid="navbar">
      <div className="px-4 md:px-12 lg:px-20 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="logo-link">
          <WeddinsiteLogo size={36} />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-stone-700">
          <NavLinks />
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <span className="hidden sm:inline text-sm text-stone-600">Hi, {user.name.split(" ")[0]}</span>
              <button onClick={() => { logout(); nav("/"); }} data-testid="logout-btn" className="px-3 py-2 text-xs sm:text-sm border border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-white transition-colors">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="login-link" className="hidden sm:inline-block px-4 py-2 text-sm text-stone-800 hover:text-black">Sign in</Link>
              <Link to="/signup" data-testid="signup-link" className="px-3 py-2 text-xs sm:text-sm bg-stone-900 text-white hover:bg-stone-800 transition-colors">Get started</Link>
            </>
          )}
          <button type="button" onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle" aria-label="Menu" className="md:hidden ml-1 p-2 border border-stone-300 hover:bg-stone-100">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {open ? (
                <path d="M18 6L6 18M6 6l12 12" />
              ) : (
                <>
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </>
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu drawer */}
      {open && (
        <div className="md:hidden border-t border-stone-200 bg-[#FDFBF7]" data-testid="mobile-menu">
          <nav className="flex flex-col px-4 py-3 gap-3 text-base text-stone-800">
            <NavLinks onClick={() => setOpen(false)} />
            {!user && (
              <Link to="/login" data-testid="nav-signin-mobile" onClick={() => setOpen(false)} className="hover:text-black">Sign in</Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
